export enum LayoutType {
    DESKTOP,
    MOBILE,
    PHONE,
}
